import { render, staticRenderFns } from "./StepPurchase.vue?vue&type=template&id=2241158c&scoped=true"
import script from "./StepPurchase.vue?vue&type=script&lang=js"
export * from "./StepPurchase.vue?vue&type=script&lang=js"
import style0 from "./StepPurchase.vue?vue&type=style&index=0&id=2241158c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2241158c",
  null
  
)

export default component.exports